import { BaseBudget } from 'typings'
import { useFormStateContext } from 'ui'
import { BuyTogetherPromotion } from '../../typings'
import { Summary } from './Summary'
import { Alerts } from './Summary/Alerts'

export function BuyTogether() {
  const { form, discountType } = useFormStateContext()

  const {
    buyTogether,
    conditions,
    general,
    restrictions,
    scheduling,
  }: BuyTogetherPromotion = form.getValues()

  return (
    <>
      <Alerts>
        <Alerts.BuyTogetherRecap buyTogether={buyTogether} />
        <Alerts.AffectedProducts />
      </Alerts>

      <Summary.Container>
        <Summary.Name name={general.name} />
        <Summary.Scheduling scheduling={scheduling} />
        <Summary.SalesChannels salesChannels={restrictions.salesChannels} />
        <Summary.Budget
          budget={restrictions.budget as BaseBudget | undefined}
        />
        <Summary.Sellers sellers={restrictions.sellers} />
        <Summary.BuyTogether discount={buyTogether} />
        <Summary.Conditions conditions={conditions} />
        <Summary.Restrictions restrictions={restrictions} />
        <Summary.Accumulate
          restrictions={restrictions}
          discountType={discountType}
        />
      </Summary.Container>
    </>
  )
}
